import { trackEvent } from './posthog';
import {
  AiPromptProperties,
  AnalyticsEvent,
  DeckCreatedProperties,
} from './events';

export { AnalyticsEvent } from './events';
export {
  capturePageview,
  identifyUser,
  initPostHog,
  isAnalyticsEnabled,
  resetAnalyticsUser,
  trackEvent,
} from './posthog';

export const trackTemplatePreviewed = (templateId: string): void => {
  trackEvent(AnalyticsEvent.templatePreviewed, { template_id: templateId });
};

export const trackDeckCreated = (properties: DeckCreatedProperties): void => {
  trackEvent(AnalyticsEvent.deckCreated, { ...properties });
};

export const trackDeckSaved = (slideCount: number): void => {
  trackEvent(AnalyticsEvent.deckSaved, { slide_count: slideCount });
};

export const trackDeckExported = (slideCount: number): void => {
  trackEvent(AnalyticsEvent.deckExported, { slide_count: slideCount });
};

export const trackAiPromptSubmitted = (properties: AiPromptProperties): void => {
  trackEvent(AnalyticsEvent.aiPromptSubmitted, { ...properties });
};

export const trackAiUpgradePromptShown = (): void => {
  trackEvent(AnalyticsEvent.aiUpgradePromptShown);
};

export const trackPricingViewed = (): void => {
  trackEvent(AnalyticsEvent.pricingViewed);
};

export const trackCheckoutStarted = (plan: string): void => {
  trackEvent(AnalyticsEvent.checkoutStarted, { plan });
};

export const trackCheckoutCompleted = (plan: string): void => {
  trackEvent(AnalyticsEvent.checkoutCompleted, { plan });
};

export const trackSignupCompleted = (method: 'email' | 'google'): void => {
  trackEvent(AnalyticsEvent.signupCompleted, { method });
};

export const trackLoginCompleted = (method: 'email' | 'google' | 'mfa'): void => {
  trackEvent(AnalyticsEvent.loginCompleted, { method });
};

export const trackLoginDrawerOpened = (nextPath: string | null): void => {
  trackEvent(AnalyticsEvent.loginDrawerOpened, {
    next_path: nextPath ?? '/',
  });
};
